// number meant to order UI groups
export const enum EntityTypeGroupId {
  Terrain = 1,
  Property = 2,
  Unit = 3,
}

export interface HaGroupId {
  group_id: EntityTypeGroupId
}

export function byGroupIdAsc(a: HaGroupId, b: HaGroupId) {
  return a.group_id - b.group_id
}
export function byGroupIdDesc(a: HaGroupId, b: HaGroupId) {
  return b.group_id - a.group_id
}
